// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"125":"126ebb46ca322db0705e","293":"e5c94c61affddfdf0569","522":"05b9e7be72ff43acdfd5"}[chunkId] + ".js";
};